import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import {
//   getCategory,
//   getSubCategory,
// } from "../../store/AsyncMethods/CategoryMethod";
import * as Yup from "yup";
import { Button } from "primereact/button";
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { RESET_ERROR } from "../../store/Types/AuthTypes";
import { toast } from "react-toastify";
import AddOrderForm from "./AddOrderForm";
import AddOrderProductForm from "./AddOrderProductForm";
import AddOrderProductTable from "./AddOrderProductTable";
import OrderCalculation from "./OrderCalculation";
import {
  getProducts,
  getspecificVarientsByProduct,
} from "../../store/AsyncMethods/ProductMethod";
import {
  addOrder,
  getOrders,
  getspecificOrder,
  updateOrder,
  changeOrderStatus,
} from "../../store/AsyncMethods/OrdersMethod";
import { getWarehouses } from "../../store/AsyncMethods/WarehouseMethod";
import { RESET_SPECIFIC_ORDER } from "../../store/Types/OrderTypes";
import { getCustomers } from "../../store/AsyncMethods/CustomerMethod";
import ShippingLabel from "../../components/OtherComponents/ShippingLabel";
import clsx from 'clsx';

// import {
//   getAllVarients,
//   getProducts,
//   getspecificVarientsByProduct,
// } from "../../store/AsyncMethods/ProductMethod";
// import { RESET_SPECIFIC_PRODUCT } from "../../store/Types/ProductTypes";

// import { getSales } from "../../store/AsyncMethods/SalesMethod";
// import { getCustomers } from "../../store/AsyncMethods/CustomerMethod";

// import {
//   addSale,
//   getSales,
//   getspecificSale,
//   updateSales,
// } from "../../store/AsyncMethods/SalesMethod";
// import { RESET_SPECIFIC_SALES } from "../../store/Types/SalesTypes";

export default function AddOrder() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { orderId } = useParams();

  // const [showProductForm, setShowProductForm] = useState(true);

  const { error, user } = useSelector((state) => state.AuthReducer);
  const { specificVarients } = useSelector((state) => state.ProductReducer);

  const { specificOrder } = useSelector((state) => state.OrderReducer);
  const { allWarehouses } = useSelector((state) => state.WarehouseReducer);

  // const [filterSubCategories, setFilterSubCategories] = useState([]);

  const [validateVarient, setValidateVarient] = useState(true);
  const [isRefund, setIsRefund] = useState(false);

  const [currentProductQuantity, setCurrentProductQuantity] = useState(0);
  const [slectedProductQuantity, setSelectedProductQuantity] = useState(0);

  // const varientOptionsValidation = varientOptions.reduce((acc, option) => {
  //   acc[option.label] = Yup.object().required(`${option.label} is required`);
  //   return acc;
  // }, {});

  const [editingProduct, setEditingProduct] = useState(null);
  const [showLabel, setShowLabel] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [trackingId, setTrackingId] = useState("");
  const [courierCompany, setCourierCompany] = useState("");

  // Courier company options
  const courierOptions = [
    { label: "Select Courier Company", value: "" },
    { label: "Leopard Courier", value: "Leopard Courier" },
    { label: "TCS", value: "TCS" },
    { label: "DHL", value: "DHL" },
    { label: "FedEx", value: "FedEx" },
    { label: "BlueEx", value: "BlueEx" },
    { label: "Call Courier", value: "Call Courier" },
    { label: "Trax", value: "Trax" },
    { label: "Other", value: "Other" }
  ];

  // Map status to tab index
  const statusTabMap = {
    to_pack: 0,
    arrange_shipment: 1,
    hand_over: 2,
    shipping: 3,
  };
  // Map tab index to status
  const tabStatusMap = [
    'to_pack',
    'arrange_shipment',
    'hand_over',
    'shipping',
  ];

  // Set active tab based on order status
  useEffect(() => {
    if (specificOrder?.status && statusTabMap[specificOrder.status] !== undefined) {
      setActiveTab(statusTabMap[specificOrder.status]);
      if (specificOrder?.tracking_id) setTrackingId(specificOrder?.tracking_id);
    }
  }, [specificOrder]);

  // Only allow visiting the current status tab
  const handleTabClick = (idx) => {
    if (idx === activeTab) setActiveTab(idx);
  };

  // Status change handlers
  const handlePrintLabel = () => {
    setShowLabel(true);
  };

  const handlePrintAndMove = async () => {
    if (specificOrder && specificOrder.id) {
       dispatch(changeOrderStatus({ id: specificOrder.id, status: 'arrange_shipment' }));
      setActiveTab(1);
    }
    window.print();
    setShowLabel(false);
  };

  const handleConfirmShipment = async () => {
    if (specificOrder && specificOrder.id) {
       dispatch(changeOrderStatus({ id: specificOrder.id, status: 'hand_over' }));
      setActiveTab(2);
    }
    toast.success('Shipment Confirmed!');
  };

  const handleConfirmHandover = async () => {
    if (specificOrder && specificOrder.id) {
       dispatch(changeOrderStatus({ 
         id: specificOrder.id, 
         status: 'shipping', 
         tracking_id: trackingId,
         courier_company: courierCompany 
       }));
      setActiveTab(3);
    }
    toast.success('Handover Confirmed!');
  };

  const editProduct = (product) => {
    setEditingProduct(product);
    // setShowProductForm(true);
  };

  useEffect(() => {
    if (specificOrder) {
      formik.setValues({
        name: specificOrder.name || "Customer",
        customerId: specificOrder.user_id || "",
        saleStatus: specificOrder.status || "pending",
        phone: specificOrder.phone || "03",
        totalPurchase: specificOrder.total_purchase || 0,
        status: specificOrder.is_active === 1 ? true : false,
        totalSales: specificOrder.total_sales || 0,
        totalDiscount: specificOrder.total_discount || 0,
        vatPer: specificOrder.vat_per || 0,
        vatAmount: specificOrder.vat_amount || 0,
        totalAmount: specificOrder.total_amount || 0,
        userId: user.id,
        vendor_id: specificOrder.vendor_id || 1, // Include vendor_id
        warehouse_id: specificOrder.warehouse_id || 1, // Include warehouse_id
        shipping_amount: specificOrder?.shipping_amount || 0,
        products: specificOrder.products || [],
        product: {
          purchasePrice: 0,
          salePrice: 0,
          product: "",
          varient: "",
          discount: 0,
          quantity: 1,
          total: 0,
          discount_value: 0,
          is_discount_percentage: true,
        },
      });
    }
  }, [specificOrder]);

  const formik = useFormik({
    initialValues: {
      name: "Customer",
      customerId: "",
      phone: "03",
      status: true,
      saleStatus: "pending",
      products: [],
      userId: user.id,
      vendor_id: 1, // Set default vendor_id
      warehouse_id: 1, // Set default warehouse_id
      totalPurchase: 0,
      totalSales: 0,
      totalDiscount: 0,
      vatPer: 0,
      vatAmount: 0,
      totalAmount: 0,
      shipping_amount: 0,
      product: {
        purchasePrice: 0,
        salePrice: 0,
        product: "",
        varient: "",
        discount: 0,
        quantity: 1,
        total: 0,
        discount_value: 0,
        is_discount_percentage: true,
      },
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Customer Name Required"),
      customerId: Yup.number().required("Customer Required"),
      vendor_id: Yup.number().required("Vendor Required"),
      warehouse_id: Yup.number().required("Warehouse Required"),
      phone: Yup.string().required("Customer Phone Number Required"),
      saleStatus: Yup.string().required("Sale Status Required"),
      status: Yup.boolean().required("Status Required"),
      product: validateVarient
        ? Yup.object().shape({
            product: Yup.number().required("Product Required"),
            varient: Yup.number().required("Variant Required"),
            varient_id: Yup.number().required("Variant ID Required"),
            properties: Yup.array().of(
              Yup.object().shape({
                name: Yup.string().required(),
                value: Yup.string().required(),
              })
            ),
            purchasePrice: Yup.number().required("Purchase Price is required"),
            salePrice: Yup.number().required("Sale Price is required"),
            discount: Yup.number().required("Discount is required"),
            quantity: Yup.number()
              .required("Quantity is required")
              .positive("Quantity should be greater than 0"),
            total: Yup.number().required("Total is required"),
            discount_value: Yup.number().nullable().transform((value) => value === null || value === undefined ? 0 : value),
            is_discount_percentage: Yup.boolean(),
          })
        : Yup.object(),
    }),

    onSubmit: async (data) => {
      if (specificOrder) {
        dispatch(updateOrder(data, orderId)).then((success) => {
          if (success) {
            formik.resetForm();
            dispatch({ type: RESET_SPECIFIC_ORDER });
            dispatch(getOrders());
            navigate(user?.role_id == 1 ? "/orders" : "/orders");
          }
        });
      } else {
        dispatch(addOrder(data)).then((success) => {
          if (success.success) {
            formik.resetForm();
            dispatch(getOrders());
            navigate("/orders");
            // navigate(
            //   user?.role_id == 1
            //     ? "/invoice-sales/" + success.insertSaleId
            //     : "/invoice-sales-sales/" + success.insertSaleId
            // );
          }
        });
      }
    },
  });

  const removeProduct = (productId) => {
    formik.setValues((prevValues) => {
      const updatedProduct = prevValues.products.filter(
        (product) => product.id !== productId
      );
      return { ...prevValues, products: updatedProduct };
    });
  };

  // useEffect(() => {
  //   if (formik?.values?.samePrice) {
  //     formik.setValues({
  //       ...formik.values,
  //       varient: {
  //         ...formik.values.varient,
  //         price: formik?.values?.price,
  //       },
  //     });
  //   } else {
  //     formik.setValues({
  //       ...formik.values,
  //       price: 0,
  //     });
  //   }
  // }, [formik?.values?.samePrice, formik?.values?.price]);

  // useEffect(() => {
  //   if (varientOptions?.length > 0) {
  //     varientOptions.map((option) => {
  //       formik.initialValues.varient = {
  //         ...formik.initialValues.varient,
  //         [option.label]: "",
  //       };
  //     });
  //   }
  // }, [varientOptions]);

  useEffect(() => {
    if (formik.values.product?.product) {
      dispatch(getspecificVarientsByProduct(formik.values.product?.product));
    }
  }, [formik.values.product?.product]);

  useEffect(() => {
    if (user) {
      dispatch(getCustomers());
      dispatch(getProducts());
      dispatch(getWarehouses());
      // dispatch(getAllVarients());
    }
  }, []);

  useEffect(() => {
    if (orderId) {
      dispatch(getspecificOrder(orderId));
      setValidateVarient(false);
      // setShowProductForm(false);
    }
  }, []);

  // useEffect(() => {
  //   dispatch({ type: RESET_SPECIFIC_SALES });
  //   formik.resetForm();
  // }, [location.pathname]);

  useEffect(() => {
    if (formik.values.product?.varient && specificVarients?.length > 0) {
      const varient = specificVarients.find(
        (varient) => varient.varient_id === formik.values.product?.varient
      );

      if (varient) {
        // formik.setFieldValue("product.purchasePrice", varient.price || "");
        setCurrentProductQuantity(varient.quantity);
      } else {
        setCurrentProductQuantity(0);
      }
    } else {
      setCurrentProductQuantity(0);
    }
  }, [formik.values.product?.varient]);

  useEffect(() => {
    if (formik.values.product.salePrice && formik.values.product.quantity) {
      formik.setFieldValue(
        "product.total",
        formik.values.product.salePrice * formik.values.product.quantity -
          formik.values.product.discount || 0
      );
    }
  }, [
    formik.values.product.salePrice,
    formik.values.product.quantity,
    formik.values.product.discount,
  ]);

  // Prevent form submission on Enter key press
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    };

    document.addEventListener("keypress", handleKeyPress);
    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, []);

  useEffect(() => {
    if (
      formik?.values?.product?.varient &&
      formik?.values?.products?.length > 0
    ) {
      const pro = formik?.values?.products.find(
        (pro) => pro.varient === formik?.values?.product?.varient
      );

      if (pro) {
        setCurrentProductQuantity(currentProductQuantity - pro.quantity);
      }
    }
  }, [slectedProductQuantity]);

  const tabHeaders = [
    { 
      label: 'Order Processing', 
      icon: 'pi pi-box', 
      description: 'Prepare and package items for shipping',
      color: 'blue'
    },
    { 
      label: 'Shipment Planning', 
      icon: 'pi pi-truck', 
      description: 'Schedule pickup with logistics partner',
      color: 'purple'
    },
    { 
      label: 'Handover', 
      icon: 'pi pi-send', 
      description: 'Transfer package to courier service',
      color: 'orange'
    },
    { 
      label: 'In Transit', 
      icon: 'pi pi-map-marker', 
      description: 'Track package delivery status',
      color: 'green'
    },
  ];

  const handleCopyTrackingId = () => {
    const idToCopy = trackingId || specificOrder?.tracking_id || '';
    if (idToCopy) {
      navigator.clipboard.writeText(idToCopy);
      toast.success('Tracking ID copied to clipboard!');
    }
  };

  return (
    <div className="mx-4">
      {/* Back Button and Preview Label */}
      <div className="mb-4 flex justify-between items-center">
        <Button
          icon="pi pi-arrow-left"
          label="Back to Orders"
          className="p-button-text"
          onClick={() => navigate('/orders')}
        />
        <Button
          label="Preview Shipping Label"
          icon="pi pi-eye"
          className="p-primary-btn"
          onClick={handlePrintLabel}
        />
      </div>

      {/* Shipping Label Modal */}
      {showLabel && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', padding: 32, borderRadius: 8, boxShadow: '0 2px 16px rgba(0,0,0,0.2)', position: 'relative' }}>
            <Button icon="pi pi-times" className="p-button-text no-print" style={{ position: 'absolute', top: 8, right: 8 }} onClick={() => setShowLabel(false)} />
            <ShippingLabel />
            <div className="flex justify-center gap-4 mt-4 no-print">
              <Button label="Print & Proceed" icon="pi pi-print" className="p-primary-btn" onClick={handlePrintAndMove} />
              <Button label="Cancel" icon="pi pi-times" className="p-primary-btn" onClick={() => setShowLabel(false)} />
            </div>
          </div>
        </div>
      )}

      {/* Custom Tab Header */}
      <div className="flex bg-white rounded-lg shadow mb-6 border border-gray-200 overflow-x-auto">
        {tabHeaders.map((tab, idx) => (
          <button
            key={tab.label}
            className={clsx(
              'flex flex-col items-center gap-2 px-6 py-4 text-base font-semibold transition-all duration-150 min-w-[200px]',
              'focus:outline-none',
              idx === activeTab
                ? `text-${tab.color}-600 border-b-4 border-${tab.color}-500 bg-${tab.color}-50 shadow-sm z-10`
                : `text-gray-600 hover:text-${tab.color}-500 border-b-4 border-transparent hover:bg-${tab.color}-50`,
              idx === 0 ? 'rounded-l-lg' : '',
              idx === tabHeaders.length - 1 ? 'rounded-r-lg' : '',
              idx !== activeTab ? 'opacity-60 cursor-not-allowed' : ''
            )}
            onClick={() => handleTabClick(idx)}
            type="button"
            disabled={idx !== activeTab}
          >
            <div className="flex items-center gap-2">
              <i className={clsx(tab.icon, 'text-xl')}></i>
              <span>{tab.label}</span>
            </div>
            <span className="text-sm font-normal text-gray-500">{tab.description}</span>
          </button>
        ))}
      </div>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          body * { background: #fff !important; }
        }
      `}</style>
      <form onSubmit={formik.handleSubmit}>
        <AddOrderForm
          formik={formik}
          isRefund={isRefund}
          setIsRefund={setIsRefund}
        />

        <div>
          <AddOrderProductForm
            formik={formik}
            // showProductForm={showProductForm}
            // setShowProductForm={setShowProductForm}
            currentProductQuantity={currentProductQuantity}
            setCurrentProductQuantity={setCurrentProductQuantity}
            validateVarient={validateVarient}
            setValidateVarient={setValidateVarient}
            editingProduct={editingProduct}
            setEditingProduct={setEditingProduct}
            setSelectedProductQuantity={setSelectedProductQuantity}
          />
        </div>

        <div className="my-3">
          <AddOrderProductTable
            products={formik.values.products}
            removeProduct={removeProduct}
            editProduct={editProduct}
          />
        </div>

        {formik.values.products?.length > 0 ? (
          <div className="my-3">
            <OrderCalculation formik={formik} />
          </div>
        ) : null}

        <div className="mt-16">
          <div className="flex justify-end gap-4">
            <Button
              label="Clear"
              icon="pi pi-times"
              className="p-red-btn"
              type="button"
              // disabled={showProductForm}
              onClick={() => {
                // dispatch({ type: RESET_SPECIFIC_PRODUCT });
                formik.resetForm();
                setIsRefund(false);
              }}
            />
            <Button
              label={"Submit"}
              icon="pi pi-check"
              className="p-secondary-btn"
              // disabled={showProductForm}
              type="submit"
            />
          </div>
        </div>
      </form>
    </div>
  );
}
